<template>
	<div>
		<b-modal v-model="mostrar_generar_factura" ref="modalGenerarFactura" size="xl" centered header-bg-variant="dark" header-text-variant="light">
		    <template #modal-header=""><h5>{{ getTitulo }}</h5></template>
			<template #default="">
				<div class="alert alert-primary">Ingrese los montos por cada R.U.T. asociados a la empresa matriz, al que desea cargar el monto total o parcial de la factura original.</div>
				<b-form id="refacturarForm">
					<div style="max-height: 180px; overflow: auto">
						<div class="ingresa-monto" v-for="(cliente, index) in getClientes" :key="index" :id="cliente._id">
							<ingresa-monto :cliente="cliente" :agregar="true"
								@evento-agregar-campo="onClickAgregarCampoEvent"
								@evento-eliminar-campo="onClickEliminarCampoEvent"
								@evento-agregar-glosa="onClickAgregarGlosaEvent">
							</ingresa-monto>
						</div>
					</div>
					<p></p>
					<div class="row">
						<div class="col-md-6">
							<b-input-group size="sm" prepend="Total desgloce">
								<b-form-input id="total_desglose" name="total_desglose" size="sm" :value="getTotalDesglose(false)" disabled />
							</b-input-group>
						</div>
						<div class="col-md-6">
							<b-input-group size="sm" prepend="Total desgloce con IVA">
								<b-form-input id="total_desglose_iva" name="total_desglose_va" size="sm" :value="getTotalDesglose(true)" disabled />
							</b-input-group>
						</div>
					</div>
					<p></p>
					<div class="row">
						<div class="col-md-6">
							<b-input-group size="sm" :prepend="'Total Folio: ' + documento.ES_id_of">
								<b-form-input id="total_folio" name="total_folio" :value="getTotalFolio(false)" disabled />
							</b-input-group>
						</div>
						<div class="col-md-6">
							<b-input-group size="sm" :prepend="'Total Folio con IVA: ' + documento.ES_id_of">
								<b-form-input id="total_folio_iva" name="total_folio_iva" :value="getTotalFolio(true)" disabled />
							</b-input-group>
						</div>
					</div>
					<p></p>
					<div class="row">
						<div class="input-group col-md-6">
							<b-input-group size="sm" prepend="Total Pendiente">
								<b-form-input id="total_pendiente" name="total_pendiente" class="text-right" :value="getTotalPendiente(false)" disabled />
							</b-input-group>
						</div>
						<div class="input-group col-md-6">
							<b-input-group size="sm" prepend="Total Pendiente con IVA">
								<b-form-input id="total_pendiente_iva" name="total_pendiente_iva" class="text-right" :value="getTotalPendiente(true)" disabled />
							</b-input-group>
						</div>
					</div>
				</b-form>
				<p></p>
				<b-alert :show="mostrar_alerta" dismissible variant="danger" class="text-center" @dismissed="mostrar_alerta=false"><h6>Monto no Facturable</h6></b-alert>
			</template>
			<template #modal-footer="">
				<b-button size="sm" variant="success" @click="refacturar">Refacturar</b-button>
				<b-button size="sm" variant="secondary" @click="cerrarGenerarFactura">Cerrar</b-button>
			</template>
		</b-modal>
		<agregar-glosa v-if="mostrar_agregar_glosa" 
			:cliente="cliente" :id="id_agregar_glosa" :factura="factura"
			:on-cerrar="onCerrarAgregarGlosa"
			:on-agregar="onAgregarGlosa"></agregar-glosa>
	</div>
</template>
<script lang="ts">

	import Vue from "vue"
	import axios from "axios"
	import { uuid } from "vue-uuid"
	import $ from "jquery"
	import moment from "moment"
	import IngresaMonto from "./ingresa_monto.vue"
	import AgregarGlosa from "./agregar_glosa.vue"


	export default {
		name: "GenerarFactura",
		components: { IngresaMonto, AgregarGlosa },
		props: {
			documento: Object, // Objeto con la informacion del documento a refacturar
			onCerrar: Function,
		},
		data() {
			return {
				clientes: {}, // Estructura con la info de todos los clientes asociados
				mostrar_generar_factura: false, // Flag que controla si se muestra o no la ventana "Refacturacion"
				mostrar_agregar_glosa: false, // Flag que controla si se muestra o no la ventana "Agregar Glosa"
				mostrar_alerta: false, // Flag que controla cuando mostrar el alerta "Monto no Facturable"
				cliente: {}, // Estructura con los datos del cliente seleccionado 
				id_agregar_glosa: "", // ID que relaciona la ventana "Agregar Glosa" con el "Ingresa Monto" para poder actualizar el campo Monto
				facturas: [], // Arreglo que guarda las facturas que se van creando
				factura: {}, // Objeto con los datos de la factura asociada al cliente
				total_desglose: 0,
				total_desglose_iva: 0,
				total_folio: 0,
				total_folio_iva: 0,
				total_pendiente: 0,
				total_pendiente_iva: 0,
				exito: false
			}
		},
        created() {

			this.total_folio = this.documento.monto_factura
			this.total_folio_iva = this.documento.monto_factura_iva
			this.total_pendiente = this.documento.monto_factura
			this.total_pendiente_iva = this.documento.monto_factura_iva

			if (this.factura != undefined)
				this.fecha_emision = moment.unix(this.factura.fecha_emision).format("DD/MM/YYYY")
		},
		mounted: function() {

			this.getClienteData()
		},
		computed: {

			getTitulo() {

				return "REFACTURACION DE FOLIO: " + this.documento.ES_id_of 
            },

			getClientes() {

				return this.clientes
			},

			// Devuelve un guid para los componentes referencia y glosa (el primero de la lista, que no se puede borrar)
			getId() {

				return uuid.v1()
			},
        },
		methods: {

			// Leemos los datos del RUT y los guardamos en la variable "clientes"
			getClienteData() {

				// Mostramos la imagen cargando
				window.event.$emit("mostrar-cargando", true)

				var rut = this.documento.client_tax_code.toString().replace(/[. ]/g, "")

                // Llamamos a la API 
				var request = {
					"usuario": this.$usuario,
					"destino": this.$env,
					"tx": "D0",
					"operacion": "clientTree",
					"cliente": { "CLIENT_TAX_CODE": rut },
				}

				axios.post("/face", request, { headers: { "Content-Type": "text/plain" } }).then(response => {

					var data = response.data
					if (data.estatus !== undefined)
					{
						this.clientes = data.data
						this.mostrar_generar_factura = true
					}

					// Ocultamos la imagen cargando
					window.event.$emit("mostrar-cargando", false)

				}).catch(ex => { 

					// Si hubo un error en la llamada, pasamos por aca
					console.log(ex.message) 

					// Ocultamos la imagen cargando
					window.event.$emit("mostrar-cargando", false)
				})
			},

			// Si se cierra la ventana Generar Factura, se cambia el valor de la variable para que no se muestre,
			// y se avisa al componente padre a traves del evento "evento-cerrar-generar-factura" para que no cree el objeto al refrescar el DOM
			cerrarGenerarFactura() {

				this.mostrar_generar_factura = false

				// Llamamos a la funcion callback asociada a la accion de cerrar la ventana
				if (this.onCerrar)
					this.onCerrar(this.exito)
			},

			// Se asume que al presionar Refacturar, se cierra la ventana
			refacturar() {

				// Si el monto de las facturas es 0, se muestra el mensaje "Monto no facturable"
				if (this.total_desglose == 0 && this.total_desglose_iva == 0)
				{
					this.mostrar_alerta = true
					return
				}

				// Recorremos todas las facturas ingresadas para armar la estructura que enviaremos al REST
				var docs_nuevos = []
				for (var f of this.facturas)
				{
					// Buscamos la info del cliente de la factura
					var cliente = this.buscarCliente(f._id)
					
					// Recorremos las glosas de la factura, para agregar el ID del cliente (requisito???) en el comentario
					f.glosas.forEach(function(g, i) {

						var comment = g.comment + " [[ " + (cliente._source.CLIENT_ID != "" ? cliente._source.CLIENT_ID : cliente._source.CLIENT_ID_MADRE) + " ]]"

						f.glosas[i].comment = comment
					})

					// Fecha de Vencimiento de la factura
					var fecha_vcto = this.expirationDate(cliente._source.PAYMENT_TERMS, f.fecha_emision)

					// Objeto temporal donde guardaremos la info de la factura
					var tmp = {
						cliente: cliente, 
						ES_id_of: this.documento.ES_id_of,
						emissionDate: f.fecha_emision,
						expirationDate: fecha_vcto,
						references: f.referencias,
						details: f.glosas,
						total_fac: f.total_fac,
						iva: f.iva
					}

					docs_nuevos.push(tmp)
				}

				// Parametros para enviar al rest
				var request = {
					usuario: this.$usuario,
					destino: this.$env,
					tx: "f1",
					operacion: "dte_fc",
					doc_original: this.documento,
					docs_nuevos: docs_nuevos,
					ES_id_of: this.documento.ES_id_of,
				}

				// Tenemos toda la info, llamamos al rest para enviarla al servidor
				axios.post("/face", request, { headers: { "Content-Type": "text/plain" } }).then(response => {

					// Parseamos el periodo seleccionado en el sistema, para obtener el ultimo dia del mes
					var tmp = this.$periodo.split("-")
					var ultimoDia = new Date(tmp[0], tmp[1], 0)

					// Armamos la fecha que se enviara a Kibana
					var fecha = tmp[0] + "-" + tmp[1] + "-" + ultimoDia

					// Llamada a la URL
					var url = this.$resturl + "/kibana/app/dashboards#/view/b998c600-3acb-11e9-a075-d56d28588383?embed=true&_g=(refreshInterval%3A(pause%3A!t%2Cvalue%3A0)%2Ctime%3A(from%3A%27" + fecha + "T00%3A00%3A00.000Z%27%2Cmode%3Aabsolute%2Cto%3A%27" + fecha + "T23%3A59%3A59.999Z%27))"

					// Mostrar el cntenido de la URL (no se si sera valido ya que se pierde la lista de documentos). Validar
					// TODO:

				}).catch(ex => {

					console.log(ex.message)
				})

				this.exito = true

				// Cambiamos el flag para cerrar la ventana
				this.mostrar_generar_factura = false

				if (this.onCerrar)
					this.onCerrar(this.exito)
					
				// Avisamos al padre para que la cierre
				this.$emit("evento-cerrar-generar-factura", false)
			},

			// Calcula la fecha de vencimiento de la factura, segun el valor de la propiedad PAYMENT_TERMS del cliente a facturar
			expirationDate(payment_terms, fecha_emision) {

				var fecha = moment.unix(fecha_emision).format("YYYY-MM-DD")

				if (payment_terms == "" || payment_terms == "null" || payment_terms == null) 
					return fecha_emision // Igual a la Fecha de Emision
				else if (payment_terms == "billing_period")
					return fecha_emision // Igual a la Fecha de Emision 
				else if (payment_terms == "manual")
					return fecha_emision  // Igual a la Fecha de Emision
				else {
					// Si el payment_terms es de la forma BILLING_PERIOD_PLUS_XX, cortamos los dias (ultimos digitos del string) 
					// y creamos la fecha de vencimiento sumando al cantidad de dias a la fecha de emision
 
					var tmp = payment_terms.split("_")
					if (tmp.length == 4)
						return moment(fecha).add(tmp[3], 'days').unix()
					else
						return fecha_emision
				}
			},

			// Buscamos los datos del cliente en el arreglo de clientes, segun el id 
			buscarCliente(id) {

				var cliente = {}
				this.clientes.forEach(function(c) {

					if (c._id == id)
					{   
						cliente = c
						return false
					}
				})


				return cliente
			},

			// Buscamos los datos del cliente en el arreglo de clientes, segun el id 
			buscarFactura(id) {

				var factura = {}
				this.facturas.forEach(function(f) {

					if (f.cid == id)
					{   
						factura = f
						return false
					}
				})


				return factura
			},

			// Buscamos la factura por su ID y la eliminamos de la lista
			eliminarFactura(id) {

				var idx = -1
				this.facturas.forEach(function(f, i) {

					if (f.cid == id)
					{
						idx = i
						return false
					}
				})

				if (idx > -1)
					this.facturas.splice(idx, 1)
			},

			// Calcula los totales cuando se hayan ingresado facturas nuevas
			calculaTotales() {

				// Si hay facturas, entonces calculamos
				if (this.facturas.length > 0)
				{
					// Primero sumamos todoas las facturas
					var total_desglose = 0
					var total_desglose_iva = 0
					this.facturas.forEach(function(f) {
	
						if (!f.iva)
							total_desglose += f.total_fac
						else
							total_desglose_iva += f.total_fac
					})
	
					// Si el monto de las facturas es 0, se muestra el mensaje "Monto no facturable"
					if (total_desglose == 0 && total_desglose_iva == 0)
						this.mostrar_alerta = true
	
					this.total_desglose = total_desglose
					this.total_desglose_iva = total_desglose_iva

					// Calculamos la diferencia por facturar
					this.total_pendiente = this.total_folio - this.total_desglose
					this.total_pendiente_iva = this.total_folio_iva - this.total_desglose_iva
				}
			},

			getTotalDesglose(iva) {

				return !iva ? Intl.NumberFormat("es-CL").format(this.total_desglose) : Intl.NumberFormat("es-CL").format(this.total_desglose_iva)
			},

			getTotalFolio(iva) {

				return !iva ? Intl.NumberFormat("es-CL").format(this.total_folio) : Intl.NumberFormat("es-CL").format(this.total_folio_iva)
			},

			getTotalPendiente(iva) {

				return !iva ? Intl.NumberFormat("es-CL").format(this.total_pendiente) : Intl.NumberFormat("es-CL").format(this.total_pendiente_iva)
			},

			// Evento para agregar un nuevo campo INGRESE MONTO en la ventana
			// Se activa cuando se presiona el icono de la izquierda "[[]" del Ingresa Monto
			onClickAgregarCampoEvent(id) {

				var cliente = this.buscarCliente(id)

				// Creamos el componente INGRESA MONTO, para agregar un nuevo campo en la ventana
				// El nuevo campo tiene el boton eliminar (parametro agregar = false)

				var component = Vue.extend(IngresaMonto)
				var o = new component({ propsData: { cliente: cliente, agregar: false } })
				o.$on("evento-eliminar-campo", this.onClickEliminarCampoEvent)
				o.$on("evento-agregar-glosa", this.onClickAgregarGlosaEvent)
				o.$mount()
				$("#" + id).append(o.$el)
			},

			// Si se elimina un objeto del "Ingresar Monto", se actualiza la lista de facturas y se recalculan los totales
			onClickEliminarCampoEvent(id) {

				// Eliminamos la factura asociada de la lista de facturas
				this.eliminarFactura(id)
				// Calculamos los totales nuevamente
				this.calculaTotales()
			},

			// Evento para mostrar la ventana Agregar Glosa
			// Se activa cuando se presiona el boton "+ Agregar" de la ventana Refacturacion
			onClickAgregarGlosaEvent(data) {

				this.cliente = this.buscarCliente(data.cliente)
				this.id_agregar_glosa = data.id
				this.factura = this.buscarFactura(data.id)
				this.mostrar_agregar_glosa = true
			},

			onCerrarAgregarGlosa(value) {

				this.mostrar_agregar_glosa = value
			},

			onAgregarGlosa(data) {

				// Si la factura existe, al eliminamos para que se actualicen los datos
				this.eliminarFactura(data.cid)

				// Agregamos la factura a la lista
				this.facturas.push(data)
				this.calculaTotales()
				this.mostrar_agregar_glosa = false
			}
		}
	}
</script>
<style scoped>

	.separador {
		margin-bottom: 5px;
	}
</style>